import { render, staticRenderFns } from "./AtomSimpleButton.vue?vue&type=template&id=6b147b05&"
import script from "./AtomSimpleButton.vue?vue&type=script&lang=js&"
export * from "./AtomSimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomSimpleButton.vue?vue&type=style&index=0&id=6b147b05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports